import React, { useEffect, useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  Button,
  theme,
  Divider,
  ConfigProvider,
  Grid,
  Form,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import name_logo from "../../assets/images/name_logo.png";
import sidebar_btn from "../../assets/images/sidebar_btn.png";
import sidebar_logo from "../../assets/images/sidebar_logo.png";
import homeIcon from "../../assets/images/homeIcon.svg";
import { CgProfile } from "react-icons/cg";
import { IoLogOut } from "react-icons/io5";

import {
  CalendarSvg,
  ChartIcon,
  HomeIcon,
  People_svg,
  QuestionMark,
  ThingsToDo,
} from "../../utils/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { logOutAws } from "../../utils/aws";
import { setIsAuthenticated } from "../../slices/authSlice";
import { setuserAttributesReducer } from "../../slices/userSlice";

import NeedHelp from "../NeedHelp";

const { Header, Sider, Content } = Layout;
const SideBar = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const checkedItems = useSelector((state) => state.preferences.checkedItems);
  const newMsgDetailObj = useSelector((state) => state.user.newMsgDetailObj);
  const [collapsed, setCollapsed] = useState(false);
  const [current, setCurrent] = useState("1");

  const location = useLocation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  console.log("🚀 ~ SideBar ~ screens:", screens.xl);
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  const isSmeApproved =
    basicInfoData?.AdminApproved && basicInfoData?.AdminApproved !== "approved";
  // const isSmeApproved =
  //   (basicInfoData?.SmeApproved == "pending" &&
  //     basicInfoData?.AdminApproved == "pending") ||
  //   (basicInfoData?.SmeApproved == "approved" &&
  //     basicInfoData?.AdminApproved == "pending");

  const handleLogout = () => {
    logOutAws();
    // localStorage.removeItem("accessToken");
    // localStorage.removeItem("username");
    dispatch(setIsAuthenticated(null));
    dispatch(setuserAttributesReducer(null));
    Navigate("/signin");
  };

  useEffect(() => {
    // if (!screens.xl) {
    //   setCollapsed(true);
    // }
    if (location.pathname === "/") {
      setCurrent("1");
    } else if (location.pathname === "/things-to-do") {
      setCurrent("2");
    } else if (location.pathname === "/communication") {
      setCurrent("3");
    } else if (location.pathname === "/calender") {
      setCurrent("4");
    } else if (location.pathname === "/talent-assessment") {
      setCurrent("5");
    } else if (location.pathname === "/portfolio") {
      setCurrent("6");
    }
  }, [location.pathname]);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const onMenuItemClick = (item) => {
    setCurrent(item.key);
    switch (item.key) {
      case "1":
        Navigate("/");
        break;
      case "2":
        Navigate("/things-to-do");
        break;
      case "3":
        Navigate("/communication");
        break;
      case "4":
        Navigate("/calender");
        break;
      case "5":
        Navigate("/talent-assessment");
        break;
      case "6":
        Navigate("/portfolio");
        break;
      // case "6":
      //   Navigate("/get-to-know");
      //   break;
      default:
        console.log("Unknown menu item");
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {},
        },
      }}
    >
      <div
        className={`py-16 px-10 bg-slate-50 rounded-3xl h-full flex flex-col cusStyle  ${
          collapsed && "items-center   "
        }  justify-between  `}
      >
        <div>
          <div
            // onClick={() => Navigate("/")}
            className="flex justify-center gap-4 w-full cursor-pointer"
          >
            <img
              src={collapsed ? sidebar_logo : name_logo}
              // onClick={toggleCollapsed}
            />
            {!collapsed && (
              <Button
                // onClick={toggleCollapsed}
                className="border-none shadow-none"
                icon={<img src={sidebar_btn} alt="sidebar_btn" />}
              />
            )}
          </div>
          {/* <Button
            className="collapse-toggle"
            type="text"
            onClick={toggleCollapsed}
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          /> */}
          <Sider
            className={!collapsed ? "sideBar_Style_collapsed" : "sideBar_Style"}
            trigger={null}
            collapsible
            collapsed={collapsed}
          >
            <Divider />
            <Menu
              className="bg-transparent border-hidden"
              mode="inline"
              defaultSelectedKeys={["1"]}
              onClick={onMenuItemClick}
              selectedKeys={[current]}
              items={
                !isSmeApproved
                  ? [
                      {
                        key: "1",
                        icon: <HomeIcon />,
                        label: !collapsed ? "Dashboard" : "",
                      },
                      {
                        key: "6",
                        icon: <CgProfile color="#FF6B38" size="1.3rem" />,
                        label: !collapsed ? "Profile" : "",
                      },
                      {
                        key: "2",
                        icon: <ThingsToDo />,
                        label: !collapsed ? "Things to do" : "",
                      },
                      {
                        key: "3",
                        icon: <People_svg />,
                        label: !collapsed
                          ? `Communications ${
                              Object.keys(newMsgDetailObj).length > 0 ? "*" : ""
                            }`
                          : "",
                      },
                      {
                        key: "4",
                        icon: <CalendarSvg />,
                        label: !collapsed ? "Calendar" : "",
                      },
                      {
                        key: "5",
                        icon: <ChartIcon />,
                        label: !collapsed ? "Talent Journey" : "",
                      },
                    ]
                  : [
                      {
                        key: "1",
                        icon: <CgProfile color="#FF6B38" size="1.3rem" />,
                        label: !collapsed ? "Profile" : "",
                      },
                    ]
              }
            />
          </Sider>
          <div className="mt-10">
            {collapsed ? <QuestionMark /> : <NeedHelp />}
          </div>
          <button
            className="flex gap-2 p-5 w-full justify-center"
            onClick={() => handleLogout()}
          >
            <IoLogOut color="#FF6B38" size="1.3rem" className="font-bold" />
            Logout
          </button>
        </div>
      </div>
    </ConfigProvider>
  );
};
export default SideBar;
